const isSecure= process.env.REACT_APP_AAWG_SERVER_IS_SECURE === 'true';

window.data = {
    AAWG_SERVER_ADDRESS: process.env.REACT_APP_AAWG_SERVER_ADDRESS,
    AAWG_SERVER_PORT: process.env.REACT_APP_AAWG_SERVER_PORT,
    AAWG_SERVER_IS_SECURE: isSecure,
    CLIENT_DESTINATION_ADDRESS: process.env.REACT_APP_CLIENT_DESTINATION_ADDRESS,
};